<template>
  <b-list-group v-if="showMenu" flush>
      <b-list-group-item  :key="route.path" v-for="route in routes"
          :to="route.path"
          :active="actualRoute == route.name"
        >
        <b-icon :icon="getIcons(route.name)" ></b-icon>
       {{ route.name }}
        </b-list-group-item
      >
    </b-list-group>
  <!-- <nav
    class="d-none bg-light sidebar"
    :class="showMenu ? 'd-md-block d-sm-block ' : ''"
  >
  <div class="sidebar-sticky"> 
    <ul class="nav nav-pills nav-justified navbar-nav">
      <li class="nav-item" :key="route.path" v-for="route in routes">
        <router-link
          class="nav-link"
          :class="{ active: actualRoute == route.name }"
          :to="route.path"
        >
          {{ route.name }}
        </router-link>
      </li>
    </ul>
    </div>
  </nav> -->
</template>
<script>
import router from "../routes";
export default {
  name: "side-menu",
  data: function () {
    //console.log(router.options.routes);
    return {
      routes: router.options.routes.filter((e) =>
        e.meta != null ? e.meta.sidemenu : false
      ),
    };
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    actualRoute() {
      return this.$route.name;
    },
  },
  methods: {
    getIcons(routeName){
      let icon="house"
      switch (routeName) {
        case "Dashboard":
          icon="graph-up"
          break;
          case "Partners":
            icon="person"
            
            break;
          case "Connections":
            icon="people"
            break;
          case "Certificates":
            icon="file-earmark-richtext"
            break;
            case "Messages":
            icon="chat-right-dots"
            break;
        default:
          icon="house"
          break;
      }
          return icon
    }
  },
};
</script>
<style>
.list-group {
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 16px;
  overflow: hidden;
  margin: 18px 12px 0 0;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.list-group-item {
  background: transparent;
  border: 0;
  border-left: 3px solid transparent;
  color: var(--text-primary);
  font-weight: 600;
  padding: 0.9rem 1.1rem 0.9rem 1.2rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.list-group-item:hover {
  background: rgba(0, 174, 239, 0.04);
  color: var(--buebchen-blue);
  border-left-color: var(--buebchen-blue);
}

.list-group-item.active {
  background: rgba(0, 174, 239, 0.1);
  color: var(--buebchen-blue);
  border-left-color: var(--buebchen-blue);
}

.list-group-item .b-icon {
  color: inherit;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 48px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.08);
  text-align: left;
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
  text-align: left;
  padding-left: 3em;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

@media (max-width: 575px) {
  .display-menu {
    display: block !important;
  }
  .d-none {
  }
}
</style>